interface IProps {
  message: Maybe<string>
}

const ErrorMessage: React.FC<IProps> = ({ message }) => (
  <p className="text-red-500 text-center w-full">
    {message || `We couldn't load this page right now. Please try again later.`}
  </p>
)
export default ErrorMessage
